// extracted by mini-css-extract-plugin
export default {"root":"SectionGrid421_root__1Lpwt","content":"SectionGrid421_content__yUoF+","gridContainer":"SectionGrid421_gridContainer__TF4ea"};